import { styled } from 'styled-components';

import { AutocompleteTextInputField } from '#/components/Form/AutocompleteTextInputField';
import { FieldErrorContainer } from '#/components/Form/Field/FieldErrorContainer';
import { cssBreakpoints } from '#/theme/theme';

export const ButtonContainer = styled.div`
  float: right;
  margin-top: -35px;
`;

export const StyledAutocompleteTextInputField = styled(
  AutocompleteTextInputField,
)`
  display: flex;
  flex-direction: column;

  ${FieldErrorContainer} {
    background: white;
    border-radius: 90px;
    margin-left: auto;
    margin-top: 5px;
    padding: 4px 8px;
  }
`;

export const FieldLabelContainer = styled.div`
  margin-right: 5px;
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
  margin-bottom: 50px;
`;

export const FormFieldContainer = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 5px;
`;

export const YearsOfExperienceInputContainer = styled.div`
  display: flex;
`;

export const IconContainer = styled.div`
  display: block;
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;

export const GeneralErrorContainer = styled.div`
  margin-top: 24px;
`;
